import React, {
  ReactNode, createContext, useEffect, useMemo, useState,
} from 'react';
import { fetchAndActivate } from 'firebase/remote-config';
import { firebaseRemoteConfig } from 'Src/firebaseSingletons';

export const remoteConfigContext = createContext({ ready: false });

interface RemoteConfigProviderProps {
  children: ReactNode;
}

export default function RemoteConfigProvider({ children }: RemoteConfigProviderProps) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    fetchAndActivate(firebaseRemoteConfig).then(() => {
      setReady(true);
    });
  }, []);

  const value = useMemo(() => ({ ready }), [ready]);

  return (
    <remoteConfigContext.Provider value={value}>
      {children}
    </remoteConfigContext.Provider>
  );
}
